import { gql } from '@apollo/client';
import {
  IOrderAddress,
  ShippingMethodCategory,
  ShippingMethodTypes,
} from '@monofront/types';

export const GET_LATE_ADD_TO_CART_ORDER_ELIGIBILITY = gql`
  query GetLateAddToCartOrderEligibility($orderId: ID!) {
    getLateAddToCartOrderEligibility(orderId: $orderId) {
      isEligible
      order {
        id
        name
      }
    }
  }
`;

export type NoteAttribute = { name: string; value: string };

export type OrderInformationsQueryResult = {
  getOrder: {
    id: string;
    shippingAddress: IOrderAddress;
    noteAttributes: NoteAttribute[];
    shippingMethodType: ShippingMethodTypes;
    shippingMethodCategory: ShippingMethodCategory;
  };
};

export type OrderInformationsQueryVariables = {
  id: string;
};

export const GET_ORDER_INFORMATIONS = gql`
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      shippingAddress {
        zip
        country
        city
        address1
        address2
        company
        name
        phone
      }
      noteAttributes {
        name
        value
      }
      shippingMethodType
      shippingMethodCategory
    }
  }
`;

export type LateAddToCartEligibleOrderQueryResult = {
  getLateAddToCartEligibleOrder: {
    id: string;
  } | null;
};

export const GET_LATE_ADD_TO_CART_ELIGIBLE_ORDER = gql`
  query GetLateAddToCartEligibleOrder {
    getLateAddToCartEligibleOrder {
      id
    }
  }
`;
